import { render } from "./ChildComponentPage.vue?vue&type=template&id=1385054b&scoped=true"
import script from "./ChildComponentPage.vue?vue&type=script&lang=js"
export * from "./ChildComponentPage.vue?vue&type=script&lang=js"

import "./ChildComponentPage.vue?vue&type=style&index=0&id=1385054b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1385054b"]])

export default __exports__